export const standingsAdjustmentFieldValues = [
  "byes",
  "draws",
  "drawsAway",
  "drawsHome",
  "forfeitsGiven",
  "forfeitsWonBy",
  "highestScoreAgainst",
  "highestScoreAgainstAway",
  "highestScoreAgainstHome",
  "highestScoreFor",
  "highestScoreForAway",
  "highestScoreForHome",
  "losses",
  "lossesAway",
  "lossesHome",
  "lowestScoreAgainst",
  "lowestScoreAgainstAway",
  "lowestScoreAgainstHome",
  "lowestScoreFor",
  "lowestScoreForAway",
  "lowestScoreForHome",
  "percentage",
  "percentageAway",
  "percentageHome",
  "played",
  "playedAway",
  "playedHome",
  "pointDifference",
  "pointDifferenceAway",
  "pointDifferenceHome",
  "position",
  "scoredAgainst",
  "scoredAgainstAway",
  "scoredAgainstHome",
  "scoredFor",
  "scoredForAway",
  "scoredForHome",
  "standingPoints",
  "standingPointsAway",
  "standingPointsHome",
  "streak",
  "streakAway",
  "streakHome",
  "washouts",
  "winPercentage",
  "winPercentageAway",
  "winPercentageHome",
  "wins",
  "winsAway",
  "winsHome",
];

const getStandingsAdjustmentFieldsWithTranslations = (formatMessage) => {
  return standingsAdjustmentFieldValues.map((v) => ({
    value: v,
    text: formatMessage({
      id: v,
      defaultMessage: v,
    }),
  }));
};

export default getStandingsAdjustmentFieldsWithTranslations;
